import { render, staticRenderFns } from "./TabAccount.vue?vue&type=template&id=4131caf0&scoped=true&"
import script from "./TabAccount.vue?vue&type=script&lang=js&"
export * from "./TabAccount.vue?vue&type=script&lang=js&"
import style0 from "./TabAccount.vue?vue&type=style&index=0&id=4131caf0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4131caf0",
  null
  
)

export default component.exports